import { makeStyles } from "@material-ui/core";

export const LotTaskStyle = makeStyles((theme) => ({
    text: {
        fontWeight: 450,
        paddingLeft: '0.5rem'
    },
}))